import React from 'react'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    approverNameText: '',
    approverPositionText: '',
    approverEmailText: '',
    calendarText: '',
    calendar_checked: true,
    contactNameText: '',
    contactPhoneText: '',
    contactEmailText: '',
    coser: '',
    districtDropdown: '',
    districtNotesText: '',
    districtRid: 0,
    docToTranslateFiles: [],
    dueDateText: '',
    educational_checked: false,
    evaluationsText: '',
    evaluations_checked: false,
    flyerText: '',
    flyer_checked: false,
    handbookText: '',
    handbook_checked: false,
    healthFormsText: '',
    healthForms_checked: false,
    iepText: '',
    iep_checked: false,
    languageDropdown: '',
    letterText: '',
    letter_checked: false,
    otherLanguageText: '',
    other_checked: false,
    otherText: '',
    permissionSlipText: '',
    permissionSlip_checked: false,
    psychological_checked: false,
    schedulesText: '',
    schedules_checked: false,
    schoolDocumentText: '',
    schoolDocument_checked: false,
    schoolDropdown: '',
    schoolRid: 0,
    socialHistory_checked: false,
    speechLanguage_checked: false,
    transcriptText: '',
    transcript_checked: false,
    translationTypes: [],
    progressBar: 0,
    leftColFilledOut: 0,
    rightColFilledOut: 0,
    backToInitialValues: 0,
    studentDistrictRid: 0,
    studentDistrictDropdown: '',
}

export const translationSlice = createSlice({
    name: "translation",
    initialState,
    reducers: {
        translationTypesUpdated: (state, action) => {
            // Always ensure it's an array
            let arr = Array.isArray(action.payload)
                ? action.payload
                : typeof action.payload === "string"
                    ? [action.payload]
                    : [];
            state.translationTypes = arr;

            // School Document
            if (state.translationTypes.includes("School Document")) {
                state.schoolDocument_checked = true;
            } else {
                state.schoolDocument_checked = false;
                state.schoolDocumentText = "";
            }
            // Evaluations
            if (state.translationTypes.includes("Evaluations")) {
                state.evaluations_checked = true;
            } else {
                state.evaluations_checked = false;
                state.evaluationsText = "";
            }
            // Other
            if (state.translationTypes.includes("Other")) {
                state.other_checked = true;
            } else {
                state.other_checked = false;
                state.otherText = "";
            }
            // Transcript
            if (state.translationTypes.includes("Transcript")) {
                state.transcript_checked = true;
            } else {
                state.transcript_checked = false;
                state.transcriptText = "";
            }
            // Letter
            if (state.translationTypes.includes("Letter")) {
                state.letter_checked = true;
            } else {
                state.letter_checked = false;
                state.letterText = "";
            }
            // IEP
            if (state.translationTypes.includes("IEP")) {
                state.iep_checked = true;
            } else {
                state.iep_checked = false;
                state.iepText = "";
            }
        },
        iepTextUpdated: (state, action) => {
            state.iepText = typeof action.payload === "string" ? action.payload : "";
        },
        iep_checkedUpdated: (state, action) => { // auto
            //state.iep_checked = action.payload;
        },
        transcriptTextUpdated: (state, action) => {
            state.transcriptText = typeof action.payload === "string" ? action.payload : "";
        },
        transcript_checkedUpdated: (state, action) => { // auto
            //state.transcript_checked = action.payload;
        },
        letterTextUpdated: (state, action) => {
            state.letterText = typeof action.payload === "string" ? action.payload : "";
        },
        letter_checkedUpdated: (state, action) => { // auto
            //state.letter_checked = typeof action.payload === "boolean" ? action.payload : false;
        },
        schoolDocumentTextUpdated: (state, action) => {
            state.schoolDocumentText = typeof action.payload === "string" ? action.payload : "";
        },
        schoolDocument_checkedUpdated: (state, action) => { // auto
            //state.schoolDocument_checked = action.payload === "boolean" ? action.payload : false;
        },
        calendarTextUpdated: (state, action) => {
            state.calendarText = typeof action.payload === "string" ? action.payload : "";
        },
        calendarCheckedUpdated: (state, action) => {
            state.calendar_checked = typeof action.payload === "boolean" ? action.payload : false;
            if (state.calendar_checked === true) {
                state.flyer_checked = false;
                state.letter_checked = false;
                state.handbook_checked = false;
                state.healthForms_checked = false;
                state.permissionSlip_checked = false;
                state.schedules_checked = false;
            }
        },
        flyerTextUpdated: (state, action) => {
            state.flyerText = typeof action.payload === "string" ? action.payload : "";
        },
        flyer_checkedUpdated: (state, action) => {
            state.flyer_checked = typeof action.payload === "boolean" ? action.payload : false;
            if (state.flyer_checked === true) {
                state.calendar_checked = false;
                state.letter_checked = false;
                state.handbook_checked = false;
                state.healthForms_checked = false;
                state.permissionSlip_checked = false;
                state.schedules_checked = false;
            }
        },
        handbookTextUpdated: (state, action) => {
            state.handbookText = typeof action.payload === "string" ? action.payload : "";
        },
        handbook_checkedUpdated: (state, action) => {
            state.handbook_checked = typeof action.payload === "boolean" ? action.payload : false;
            if (state.handbook_checked === true) {
                state.calendar_checked = false;
                state.flyer_checked = false;
                state.letter_checked = false;
                state.healthForms_checked = false;
                state.permissionSlip_checked = false;
                state.schedules_checked = false;
            }
        },
        healthFormsTextUpdated: (state, action) => {
            state.healthFormsText = typeof action.payload === "string" ? action.payload : "";
        },
        healthForms_checkedUpdated: (state, action) => {
            state.healthForms_checked = typeof action.payload === "boolean" ? action.payload : false;
            state.calendar_checked = false;
            state.flyer_checked = false;
            state.letter_checked = false;
            state.handbook_checked = false;
            state.permissionSlip_checked = false;
            state.schedules_checked = false;
        },
        permissionSlipTextUpdated: (state, action) => {
            state.permissionSlipText = typeof action.payload === "string" ? action.payload : "";
        },
        permissionSlip_checkedUpdated: (state, action) => {
            state.permissionSlip_checked = typeof action.payload === "boolean" ? action.payload : false;
            if (state.permissionSlip_checked === true) {
                state.calendar_checked = false;
                state.flyer_checked = false;
                state.letter_checked = false;
                state.handbook_checked = false;
                state.healthForms_checked = false;
                state.schedules_checked = false;
            }
        },
        schedulesTextUpdated: (state, action) => {
            state.schedulesText = typeof action.payload === "string" ? action.payload : "";
        },
        schedules_checkedUpdated: (state, action) => {
            state.flyer_checked = typeof action.payload === "boolean" ? action.payload : false;
            if (state.flyer_checked === true) {
                state.schedules_checked = true;
                state.calendar_checked = false;
                state.flyer_checked = false;
                state.letter_checked = false;
                state.handbook_checked = false;
                state.healthForms_checked = false;
                state.permissionSlip_checked = false;
            }
        },
        evaluationsTextUpdated: (state, action) => {
            state.evaluationsText = typeof action.payload === "string" ? action.payload : "";
        },
        evaluations_checkedUpdated: (state, action) => { // auto
            state.evaluations_checked = typeof action.payload === "boolean" ? action.payload : false;
        },
        psychological_checkedUpdated: (state, action) => {
            state.psychological_checked = typeof action.payload === "boolean" ? action.payload : false;
        },
        educational_checkedUpdated: (state, action) => {
            state.educational_checked = typeof action.payload === "boolean" ? action.payload : false;
        },
        socialHistory_checkedUpdated: (state, action) => {
            state.socialHistory_checked = typeof action.payload === "boolean" ? action.payload : false;
        },
        speechLanguage_checkedUpdated: (state, action) => {
            state.speechLanguage_checked = typeof action.payload === "boolean" ? action.payload : false;
        },
        otherLanguageTextUpdated: (state, action) => {
            state.otherLanguageText = typeof action.payload === "string" ? action.payload : "";
        },
        other_checkedUpdated: (state, action) => { // auto
            state.other_checked = typeof action.payload === "boolean" ? action.payload : false;
        },
        otherTextUpdated: (state, action) => {
            state.otherText = typeof action.payload === "string" ? action.payload : "";
        },
        dueDateTextUpdated: (state, action) => {
            let dateString = "";
            if (typeof action.payload === "string" || action.payload instanceof Date) {
                let temp = action.payload.toString().substring(0, 10);
                let temp2 = temp.split("-");
                if (temp2.length === 3) {
                    dateString = temp2[0] + "-" + temp2[1] + "-" + temp2[2];
                }
            }
            state.dueDateText = dateString;
        },
        districtDropdownUpdated: (state, action) => {
            state.districtDropdown = typeof action.payload === "string" ? action.payload : "";
            state.schoolDropdown = "";
            //state.coser = "";
            state.studentDistrictDropdown = "";
        },
        districtRidUpdated: (state, action) => {
            state.districtDropdown = typeof action.payload === "string" ? action.payload : "";
        },
        schoolDropdownUpdated: (state, action) => {
            state.schoolDropdown = typeof action.payload === "string" ? action.payload : "";
        },
        schoolRidUpdated: (state, action) => {
            state.schoolRid = typeof action.payload === "number" ? action.payload : 0;
        },
        languageDropdownUpdated: (state, action) => {
            state.languageDropdown = typeof action.payload === "string" ? action.payload : "";
            state.otherLanguageText = "";
        },
        contactNameTextUpdated: (state, action) => {
            state.contactNameText = typeof action.payload === "string" ? action.payload : "";
        },
        contactPhoneTextUpdated: (state, action) => {
            state.contactPhoneText = typeof action.payload === "string" ? action.payload : "";
        },
        contactEmailTextUpdated: (state, action) => {
            state.contactEmailText = typeof action.payload === "string" ? action.payload : "";
        },
        approverNameTextUpdated: (state, action) => {
            state.approverNameText = typeof action.payload === "string" ? action.payload : "";
        },
        approverPositionTextUpdated: (state, action) => {
            state.approverPositionText = typeof action.payload === "string" ? action.payload : "";
        },
        approverEmailTextUpdated: (state, action) => {
            state.approverEmailText = typeof action.payload === "string" ? action.payload : "";
        },
        districtNotesTextUpdated: (state, action) => {
            state.districtNotesText = typeof action.payload === "string" ? action.payload : "";
        },
        coserUpdated: (state, action) => {
            state.coser = typeof action.payload === "string" ? action.payload : "";
        },
        studentDistrictDropdownUpdated: (state, action) => {
            state.studentDistrictDropdown = typeof action.payload === "string" ? action.payload : "";
        },
        studentDistrictRidUpdated: (state, action) => {
            state.studentDistrictDropdown = typeof action.payload === "string" ? action.payload : "";
        },

        docToTranslateFilesUpdated: (state, action) => {
            state.docToTranslateFiles = [action.payload][0]
        },

        intakeRunOnceUpdated: (state, action) => {
            state.intakeRunOnce = action.payload;
        },
        progressBarUpdated: (state, action) => {
            state.progressBar = state.leftColFilledOut + state.rightColFilledOut;
        },
        rightColFilledOutUpdated: (state, action) => {
            let tempVal = 0;
            if (state.dueDateText.length > 0){
                tempVal += 5;
            }
            if (state.districtDropdown.length > 0){
                tempVal += 5;
            }
            if (!state.districtDropdown.includes("Nassau BOCES")){
                tempVal += 2;
            }
            else if (state.districtDropdown.includes("Nassau BOCES") > 0  && state.coser.length > 0){
                tempVal += 2;
            }
            if (state.schoolDropdown.length > 0){
                tempVal += 5;
            }
            if (state.languageDropdown == "Other"){
                if (state.otherLanguageText.length > 0) tempVal += 5;
            }
            else if (state.languageDropdown.length > 0 && state.languageDropdown != "Other"){
                tempVal += 5;
            }
            if (state.contactNameText.length > 0){
                tempVal += 5;
            }
            if (state.contactPhoneText.length > 0){
                tempVal += 5;
            }
            if (state.contactEmailText.length > 0){
                tempVal += 4;
            }
            if (state.approverNameText.length > 0){
                tempVal += 4;
            }
            if (state.approverPositionText.length > 0){
                tempVal += 4;
            }
            if (state.approverEmailText.length > 0){
                tempVal += 4;
            }
            if (!state.districtDropdown.includes("Regional Summer School") && 
                    !state.schoolDropdown.includes("RSIP")){
                tempVal += 2;
            }
            else if ((state.districtDropdown.includes("Regional Summer School") || 
                state.schoolDropdown.includes("RSIP")) 
                && state.studentDistrictDropdown.length > 0){
                tempVal += 2;
            }
            
            state.rightColFilledOut = tempVal;
            state.progressBar = Math.min(state.leftColFilledOut + state.rightColFilledOut,100);
        },
        leftColFilledOutUpdated: (state, action) => {
            let tempVal = 0;
            if (state.translationTypes.length > 0){
                if (!state.translationTypes.includes("IEP")){
                    tempVal += 9;
                }
                else{
                    if (state.iepText.length > 0){
                        tempVal += 9;
                    }
                }
                if (!state.translationTypes.includes("Transcript")){
                    tempVal += 9;
                }
                else{
                    if (state.transcriptText.length > 0){
                        tempVal += 9;
                    }
                }
                if (!state.translationTypes.includes("Letter")){
                    tempVal += 8;
                }
                else{
                    if (state.letterText.length > 0){
                        tempVal += 8;
                    }
                }
                if (!state.translationTypes.includes("School Document")){
                    tempVal += 8;
                }
                else{
                    if (state.schoolDocumentText.length > 0){
                        tempVal += 8;
                    }
                }
                if (!state.translationTypes.includes("Evaluations")){
                    tempVal += 8;
                }
                else{
                    if (state.evaluationsText.length > 0){
                        tempVal += 8;
                    }
                }
                if (!state.translationTypes.includes("Other")){
                    tempVal += 8;
                }
                else{
                    if (state.otherText.length > 0){
                        tempVal += 8;
                    }
                }
            }
            else tempVal = 0;
            
            state.leftColFilledOut = tempVal;
            state.progressBar = Math.min(state.leftColFilledOut + state.rightColFilledOut,100);
        },
        backToInitialValuesUpdated: (state, action) => {
            state.backToInitialValues = action.payload;
            state.approverNameText = '';
            state.approverPositionText = '';
            state.approverEmailText = '';
            state.calendarText = '';
            state.calendar_checked = true;
            state.contactNameText = '';
            state.contactPhoneText = '';
            state.contactEmailText = '';
            state.coser = '';
            state.districtDropdown = '';
            state.districtNotesText = '';
            state.districtRid = 0;
            state.docToTranslateFiles = [];
            state.dueDateText = '';
            state.educational_checked = false;
            state.evaluationsText = '';
            state.evaluations_checked = false;
            state.flyerText = '';
            state.flyer_checked = false;
            state.handbookText = '';
            state.handbook_checked = false;
            state.healthFormsText = '';
            state.healthForms_checked = false;
            state.iepText = '';
            state.iep_checked = false;
            state.languageDropdown = '';
            state.letterText = '';
            state.letter_checked = false;
            state.otherLanguageText = '';
            state.other_checked = false;
            state.otherText = '';
            state.permissionSlipText = '';
            state.permissionSlip_checked = false;
            state.psychological_checked = false;
            state.schedulesText = '';
            state.schedules_checked = false;
            state.schoolDocumentText = '';
            state.schoolDocument_checked = false;
            state.schoolDropdown = '';
            state.schoolRid = 0;
            state.socialHistory_checked = false;
            state.speechLanguage_checked = false;
            state.transcriptText = '';
            state.transcript_checked = false;
            state.translationTypes = [];
            state.progressBar = 0;
            state.leftColFilledOut = 0;
            state.rightColFilledOut = 0;
            state.schoolDistrictRid = 0;
            state.schoolDistrictDropdown = '';
        },

    },
  });
  
export const { backToInitialValuesUpdated, leftColFilledOutUpdated, rightColFilledOutUpdated, progressBarUpdated, translationTypesUpdated, iepTextUpdated, iep_checkedUpdated, transcriptTextUpdated, transcript_checkedUpdated, letterTextUpdated, letter_checkedUpdated, schoolDocumentTextUpdated, schoolDocument_checkedUpdated, calendarTextUpdated, calendarCheckedUpdated, flyerTextUpdated, flyer_checkedUpdated, handbookTextUpdated, handbook_checkedUpdated, healthFormsTextUpdated, healthForms_checkedUpdated, permissionSlipTextUpdated, permissionSlip_checkedUpdated, schedulesTextUpdated, schedules_checkedUpdated, evaluationsTextUpdated, evaluations_checkedUpdated, psychological_checkedUpdated, educational_checkedUpdated, socialHistory_checkedUpdated, speechLanguage_checkedUpdated, otherLanguageTextUpdated, other_checkedUpdated, otherTextUpdated, dueDateTextUpdated, districtDropdownUpdated, districtRidUpdated, schoolDropdownUpdated, schoolRidUpdated, languageDropdownUpdated, contactNameTextUpdated, contactPhoneTextUpdated, contactEmailTextUpdated, approverNameTextUpdated, approverPositionTextUpdated, approverEmailTextUpdated, districtNotesTextUpdated, coserUpdated, docToTranslateFilesUpdated, studentDistrictDropdownUpdated, studentDistrictRidUpdated,intakeRunOnceUpdated } = translationSlice.actions;

export default translationSlice.reducer;
